<template>
  <div class="container">
    <navComponent />
    <div class="bgcImg">
      <div class="title1">关于我们</div>
      <div class="title2">给 您 带 来 极 致 服 务</div>
    </div>
    <div class="contentBox">
      <div class="contentTitle">
        <div class="world1">公司介绍</div>
        <div class="world2" style="text-align: left">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          杭州众腾信安科技有限公司（简称：Spxlogic），是一家专注于机器数据分析平台的公司。我们立志于打造面向未来的大规模、实时、智能化的云原生数据监测和分析引擎，及在此之上构建数据安全（SIEM）和智能运维（AIOPS）等一系列服务，帮助客户更快的从海量数据中定位问题并提供解决方案。目前公司已发布日志审计等安全产品，并已取得规模应用。<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司总部位于杭州，核心团队均来自国内知名厂商，员工超过60%为研发人员，具有覆盖全国的销售和服务支持的能力。未来，我们将持续加大研发投入，不断完善产品与解决方案，为客户创造更大价值。<br />
        </div>
        <div class="world2">
          使命：让机器数据，为客户创造最大业务价值<br />
          目标：成为国内机器数据分析平台领域的领导者
        </div>
      </div>
      <div class="contentTitle">
        <div class="world1">以下方式可以联系我们</div>
        <div class="contentBoxIner">
          <div class="picText">杭州总公司</div>
          <div class="picContent">
            地址：浙江省-杭州市-建业路511号华创大厦15层1509室<br />邮箱地址：service@spxlogic.com
          </div>
        </div>
      </div>
      <div class="contentTitle">
        <div class="world1">留下您的信息</div>
        <div class="world2">您可以在这里留下您的信息，稍后我们会有专人为您服务</div>
      </div>
      <div class="formText">
        您的称呼
        <el-input v-model="form.username"></el-input>
        您的单位名称
        <el-input v-model="form.comname"></el-input>
        您的电话
        <el-input v-model="form.phone"></el-input>
        您的邮箱
        <el-input v-model="form.email"></el-input>
        联系内容
        <el-input v-model="form.content" type="textarea" resize="none" :rows="6"></el-input>
        <el-button type="primary" style="float: right; margin-top: 30px">提交留言</el-button>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: '',
        comname: '',
        phone: '',
        email: '',
        content: '',
        form: {
          username: '',
          comname: '',
          phone: '',
          email: '',
          content: '',
        },
      };
    },
    methods: {},
  };
</script>

<style lang="css" scoped>
  .bgcImg {
    margin-top: 46px;
    width: 100%;
    text-align: center;
    color: #fff;
    height: 200px;
    background: url(../asset/home2.png) top center no-repeat;
    background-size: cover;
  }
  .title1 {
    padding: 20% 0 5% 0;
    font-size: 18px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    line-height: 13px;
  }
  .title2 {
    font-size: 14px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
  }

  .contentBox {
    padding: 0 7%;
    background-color: #fff;
  }
  .contentTitle {
    text-align: center;
  }
  .world1 {
    padding: 30px 0 10px 0;
    font-size: 16px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.6);
    line-height: 22px;
    letter-spacing: 3px;
  }
  .world2 {
    font-size: 12px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
  .contentBoxIner {
    margin-top: 20px;
    padding: 5% 4%;
    width: 100%;
    height: 123px;
    background: #ffffff;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.06);
  }
  .boxL {
    height: 70px;
  }
  .boxR {
    height: 70px;
    margin-top: 38px;
  }
  .picText {
    text-align: center;
    font-size: 16px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.8);
    line-height: 30px;
  }
  .picContent {
    text-align: left;
    font-size: 12px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.6);
    line-height: 30px;
  }

  .contentBox2 {
    margin-top: 20px;
    padding: 0 7%;
  }
  .contentBox3 {
    padding: 0 7%;
    margin-bottom: 58px;
  }
  .formText {
    margin: 30px 0 100px 0;
    font-size: 16px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.6);
    line-height: 40px;
  }
</style>
